import React from "react";
export default function Location() {
  return (
    <section className="container mx-auto px-4 py-10">
      <h2 className="text-3xl font-bold text-green-700 mb-6">Our Location</h2>
      <p className="text-gray-700">Located in Liberty City, Florida</p>
      <p className="text-gray-700">123 Learning Lane, Liberty City, FL 33142</p>
    </section>
  );
}
